
export function buildStructuredDataSnippet(type: string, data: object) {
  const commonData = {
    "@type": type,
    "@context": "http://schema.org",
  };
  const structuredData = {...commonData, ...data};

  return {
    type: "application/ld+json",
    innerHTML: JSON.stringify(structuredData),
  };
}

export function buildMetaTags(
  details: IContentMeta | ILocation | ISampleItinerarySummary,
  url: string,
  heroImage: IContentImage | ILocationImage,
  fallbacks = {},
  extraTags = []
) {
  const getOrNull = (details, field) => details ? details[field] : null;
  
  // our default title fallback is details.name, but IContentMeta doesn't have a .name
  const title = getOrNull(details, 'titleTag') || fallbacks['title'] || getOrNull(details, 'name');
  const description = getOrNull(details, 'descriptionTag');

  const metaTagArray = [
    { name: "description", content: description },
    { property: "og:title", content: title },
    { property: "og:description", content: description },
    { property: "og:url", content: url},
    ...extraTags
  ];

  if (heroImage) {
    metaTagArray.push(
      { property: "og:image", content: heroImage.smallUrl},
    );
  }
  return metaTagArray;
}
